var some = require('./some');

    /**
     * Check if object contains value
     */
    function contains(obj, needle) {
        return some(obj, function(val) {
            return (val === needle);
        });
    }
    module.exports = contains;





//////////////////
// WEBPACK FOOTER
// ./~/mout/object/contains.js
// module id = 706
// module chunks = 0 1 2